import { Settings } from "../../../Settings";
import GridTile from "../../grid/GridTile";
import Vector from "../../math/Vector";
import Character from "../../character/Character";
import PathPlan from "./PathPlan";

export default class PathPlanJumpLeft extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     * @param {number} jumpHeight
     */
    constructor(startTile, endTile, pathSteps, jumpHeight) {
        super(startTile, endTile, pathSteps);

        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.jumpCoordinate = new Vector(0, 0);
        /**
         * @private
         * @type {Vector}
         */
        this.landCoordinate = new Vector(0, 0);
        /**
         * @constant
         * @type {number}
         */
        this.jumpHeight = jumpHeight;
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        this.jumpCoordinate.copy(this.startTile.origin);
        //this.jumpCoordinate.addXY(Settings.character.halfWidth, 0);
        this.jumpCoordinate.subtractXY(Settings.character.halfWidth, 0);
        const jumpCoordinateX = this.jumpCoordinate.x;
        
        /////////////////////////////////////////////
        // Walk to jump coordinate
        /////////////////////////////////////////////

        if (character.position.worldCoordinateCenter.x > jumpCoordinateX) {
            this.walkLeftToCenterX(character, frameTimeRatio, jumpCoordinateX);
            return false;
        }

        /////////////////////////////////////////////
        // Jump up & Left
        /////////////////////////////////////////////

        // Land center of end tile
        this.landCoordinate.copy(this.endTile.origin);
        this.landCoordinate.addXY(Settings.tile.halfSize, 0);
        
        if (character.position.worldCoordinateCenter.x > this.landCoordinate.x || character.position.worldCoordinateOrigin.y < this.endTile.origin.y) {
            this.jumpLeft(character, frameTimeRatio, this.jumpCoordinate, this.landCoordinate, this.jumpHeight);
            return false;
        }

        this.assertEndTileReached(character, this.endTile);
        
        return true;
    }
    
    /**
     * @returns {String}
     */
    toString() {
        return 'JumpLeft(' + this.pathSteps + ')';
    }
}